import styled from 'styled-components';

export const Container = styled.div`
  max-width: 300px;
  width: 100%;
  display: grid;
  grid-gap: 10px;
  height: fit-content;
  z-index: 1;
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: bold;
`;
